import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { adminMe, getToken, clearToken } from "@/lib/adminApi";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminDashboard from "@/components/admin/AdminDashboard";

const Admin = () => {
  const [user, setUser] = useState(undefined); // undefined = checking

  useEffect(() => {
    if (!getToken()) { setUser(null); return; }
    adminMe()
      .then((u) => setUser(u))
      .catch(() => { clearToken(); setUser(null); });
  }, []);

  if (user === undefined) {
    return (
      <div className="grid min-h-screen place-items-center bg-[#0a2540]">
        <Loader2 className="h-6 w-6 animate-spin text-white" />
      </div>
    );
  }

  if (!user) return <AdminLogin onSuccess={setUser} />;
  return <AdminDashboard user={user} onLogout={() => setUser(null)} />;
};

export default Admin;
